import {useState} from 'react';

import {useAnimationConfigurator, useKeyboardState} from '../LoginForm.hook';

export const useHeader = () => {
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const animationConfigurator = useAnimationConfigurator();
  const {isKeyboardShown} = useKeyboardState({
    animationEffect: animationConfigurator,
  });

  // imageWidth * 0.55 - the actual vertical space that the logo fills in
  const space = (imageHeight - imageWidth * 0.55) / 2;
  const marginVertical = space > 0 ? space : 0;

  const gutterStyle = isKeyboardShown ? {marginVertical: -marginVertical} : {};

  const onLayout = ({
    nativeEvent: {
      layout: {width, height},
    },
  }: any) => {
    setImageWidth(width);
    setImageHeight(height);
  };

  return {
    gutterStyle,
    setImageHeight,
    setImageWidth,
    imageWidth,
    imageHeight,
    onLayout,
  };
};
